import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';
import s from './Badge.module.css';

export type Tone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger' | 'info';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  icon?: ReactNode;
}

export function Badge({ tone = 'neutral', icon, className, children, ...rest }: BadgeProps) {
  return (
    <span className={cx(s.badge, s[tone], className)} {...rest}>
      {icon}
      {children}
    </span>
  );
}

export type PresenceStatus = 'online' | 'offline' | 'busy' | 'warning' | 'error';

const statusTone: Record<PresenceStatus, string> = {
  online: 'dotSuccess',
  offline: 'dotNeutral',
  busy: 'dotInfo',
  warning: 'dotWarning',
  error: 'dotDanger',
};

export interface StatusDotProps {
  status: PresenceStatus;
  /** Libellé affiché à côté du point (aussi lu par les lecteurs d'écran). */
  label?: string;
  pulse?: boolean;
}

/** Point de statut + libellé : la couleur n'est jamais le seul indicateur. */
export function StatusDot({ status, label, pulse }: StatusDotProps) {
  return (
    <span className={s.status}>
      <span className={cx(s.dot, s[statusTone[status]], pulse && status === 'online' && s.pulse)} aria-hidden="true" />
      {label && <span>{label}</span>}
    </span>
  );
}
